import { defineStore } from "pinia";
import AppConfigService from "@/services/AppConfigService";

// Store przechowujący konfigurację aplikacji pobraną z backendu — przede wszystkim flagi funkcji
// (parametryzowane po stronie backendu w .env / .env.local). Ładowany raz po zalogowaniu.
export const useConfigStore = defineStore({
  id: "config",
  state: () => ({
    // Flagi funkcji. Domyślnie wszystko wyłączone, aż do pobrania z API.
    featureFlags: {
      locationManagement: false,
    },
    _loaded: false,
    _loadPromise: null,
  }),
  actions: {
    // Pobiera flagi funkcji z backendu. Idempotentne — pobiera tylko raz (chyba że force=true).
    async loadFeatureFlags(force = false) {
      if (!force && this._loaded) {
        return this.featureFlags;
      }
      if (!force && this._loadPromise) {
        return this._loadPromise;
      }

      this._loadPromise = (async () => {
        try {
          const flags = await AppConfigService.getFeatureFlags();
          this.featureFlags = {
            ...this.featureFlags,
            ...(flags || {}),
          };
          this._loaded = true;
        } catch (error) {
          // Brak flag = funkcje pozostają wyłączone. Nie blokujemy działania aplikacji.
          console.error("Nie udało się pobrać flag funkcji:", error);
        }
        return this.featureFlags;
      })();

      try {
        return await this._loadPromise;
      } finally {
        this._loadPromise = null;
      }
    },
    // Reset stanu (np. przy wylogowaniu).
    reset() {
      this.featureFlags = { locationManagement: false };
      this._loaded = false;
      this._loadPromise = null;
    },
  },
});
